
import axios from "axios";

export const baseurl = process.env.REACT_APP_BASE_URL;
export const imagebaseurl = process.env.REACT_APP_IMAGE_BASE_URL;

export const API_URL = {
  GetDashboard: 'secure/data',

  SaveOverview: "Overview/SaveOverview",
  GetOverview: "overview/data",
  GetOverviewById: "Overview/GetOverviewById",
  DeleteOverviewById: "Overview/DeleteOverviewById",

  SaveJoinTeamSection: "JoinTeamSection/SaveJoinTeamSection",
  GetJoinTeamSection: "JoinTeamSection/GetJoinTeamSection",
  GetJoinTeamSectionById: "JoinTeamSection/GetJoinTeamSectionById",
  DeleteJoinTeamSectionById: "JoinTeamSection/DeleteJoinTeamSectionById",
  ActiveJoinTeamSectionById: "JoinTeamSection/ActiveJoinTeamSectionById",

  GetMenu: "Menus/GetMenu",
  getMenusWithRole: "Menus/getMenusWithRole",

  SaveFaqs: "Faqs/SaveFaqs",
  GetFaqs: "Faqs/GetFaqs",
  GetFaqsById: "Faqs/GetFaqsById",
  GetFaqsByCategoryId: "Faqs/GetFaqsByCategoryId",
  GetFaqsAll: "Faqs/GetFaqsAll",
  DeleteFaqsById: "Faqs/DeleteFaqsById",

  SaveServiceIndustry: 'ServiceIndustry/SaveServiceIndustry',
  GetServiceIndustry: "ServiceIndustry/GetServiceIndustry",
  DeleteServiceIndustry: "ServiceIndustry/DeleteServiceIndustry",

  SaveServiceDetail: 'ServiceDetail/SaveServiceDetail',
  GetServiceDetails: "ServiceDetail/GetServiceDetail",
  GetServiceDetailByServiceSlug: "ServiceDetail/GetServiceDetailByServiceSlug",
  DeleteServiceDetail: "ServiceDetail/DeleteServiceDetail",
  GetServiceDetailByServiceId: 'ServiceDetail/GetServiceDetailByServiceId',

  SaveCreative: "Creative/SaveCreative",
  GetCreative: "creative/data",
  DeleteCreativeById: "Creative/DeleteCreativeById",


  saveService: 'Service/SaveService',
  getServices: 'Service/getServices',
  deleteService: 'Service/deleteService',
  ActiveServiceById: 'Service/ActiveServiceById',
  FooterServiceById: 'Service/FooterServiceById',

  SaveMobileSection: 'MobileSection/SaveMobileSection',
  GetMobileSection: 'MobileSection/GetMobileSection',
  GetMobileSectionById: 'MobileSection/GetMobileSectionById',
  DeleteMobileSectionById: 'MobileSection/DeleteMobileSectionById',

  SaveTheme: 'Theme/SaveTheme',
  GetThemes: 'Theme/GetThemes',
  GetThemeById: 'Theme/GetThemeById',
  DeleteThemeById: 'Theme/DeleteThemeById',

  SaveProductDetail: 'Product/SaveProductDetail',
  GetProductDetail: 'Product/GetProductDetail',
  GetProductDetailByProductId: 'Product/GetProductDetailByProductId',
  DeleteProductDetailById: 'Product/DeleteProductDetailById',

  GetProductById: 'Product/GetProductById',

  SaveCollaborate: 'Collaborate/SaveCollaborate',
  GetCollaborate: 'Collaborate/GetCollaborate',
  DeleteCollaborateById: 'Collaborate/DeleteCollaborateById',
  ActiveCollaborateById: 'Collaborate/ActiveCollaborateById',

  GetBlogDetailAll: "BlogDetail/GetBlogDetailAll",
  SaveBlogDetail: "BlogDetail/SaveBlogDetail",
  GetProductAll: "Product/GetProductAll",
  SaveProduct: "Product/SaveProduct",

  SaveWorkType: 'WorkType/SaveWorkType',
  GetWorkType: "WorkType/GetWorkType",
  DeleteWorkTypeById: 'WorkType/DeleteWorkTypeById',
  ActiveWorkTypeById: 'WorkType/ActiveWorkTypeById',

  SaveEnquiry: "Enquiry/SaveEnquiry",
  GetTechPartnerHomePage: "TechPartner/GetTechPartnerHomePage",
  GetImageDetailByImageType: "ImageDetail/GetImageDetailByImageType",
  GetTestimonialApproved: "Testimonial/GetTestimonialApproved",
  SentOtp: "SentOtp/SentOtp",
  VerifyOTP: "SentOtp/VerifyOTP",
  GetLoginDetailByUserName: "LoginDetail/GetLoginDetailByUserName",
  GetMenuDetailByTypeId: "RolePermission/GetMenuDetailByTypeId",
  DeleteBlogDetailById: "BlogDetail/DeleteBlogDetailById",
  SaveImageDetail: "ImageDetail/SaveImageDetail",
  GetImageDetail: "ImageDetail/GetImageDetail",
  DeleteImageDetailById: "ImageDetail/DeleteImageDetailById",

  SaveProjectDetail: "ProjectDetail/SaveProjectDetail",
  DeleteProjectDetailById: "ProjectDetail/DeleteProjectDetailById",
  GetProjectDetail: "ProjectDetail/GetProjectDetailHomeDisplay",
  GetProjectDetailAll: "ProjectDetail/GetProjectDetail",
  IsHomeDisplayProjectDetailById: "ProjectDetail/IsHomeDisplayProjectDetailById",


  SaveTechPartner: "TechPartner/SaveTechPartner",
  DeleteTechPartnerById: "TechPartner/DeleteTechPartnerById",
  GetTechPartner: "TechPartner/GetTechPartner",
  IsHomeDisplayTechPartnerById: "TechPartner/IsHomeDisplayTechPartnerById",

  SaveClientDetail: "ClientDetail/SaveClientDetail",
  DeleteClientDetailById: "ClientDetail/DeleteClientDetailById",
  GetClientDetail: "ClientDetail/GetClientDetail",

  SaveTestimonial: "Testimonial/SaveTestimonial",
  DeleteTestimonialById: "Testimonial/DeleteTestimonialById",
  GetTestimonial: "Testimonial/GetTestimonial",
  ApprovalTestimonialById: "Testimonial/ApprovalTestimonialById",

  GetEnquiry: "Enquiry/GetEnquiry",
  SaveJobPost: "JobPost/SaveJobPost",
  GetJobPost: "JobPost/GetJobPost",
  DeleteJobPostById: "JobPost/DeleteJobPostById",
  GetPostEnquiry: "PostEnquiry/GetPostEnquiry",
  ActiveJobPostById: "JobPost/ActiveJobPostById",

  SaveBlogType: "BlogType/SaveBlogType",
  GetBlogType: "BlogType/GetBlogType",
  DeleteBlogTypeById: "BlogType/DeleteBlogTypeById",

  GetQuotation: "Quotation/GetQuotation",

  GetPortfolioType: 'PortfolioType/GetPortfolioType',
  DeletePortfolioTypeById: 'PortfolioType/DeletePortfolioTypeById',
  SavePortfolioType: 'PortfolioType/SavePortfolioType',

  DeleteProductById: 'Product/DeleteProductById',

  IsHomeDisplayProductById: 'Product/IsHomeDisplayProductById'
}

const axiosIns = axios.create({
  baseURL: baseurl,
  headers: {
    'Content-Type': 'application/json'
  }
});
export default axiosIns;
